module.exports = __webpack_public_path__ + "static/collaborate@2x-cc2eeaee96716746c9f5bd84a9b4ca31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/consultancies/collaborate@2x.jpg
// module id = 2541
// module chunks = 56719701542624